import { cn } from '@repo/tailwind-config/tailwind.functions'
import { SVGFC } from '@repo/toolkit/types'

const HomeIcon: SVGFC = ({ color = 'white', filled, isIconFilled, fill = 'none', ...props }) => {
  const isFilled = filled || isIconFilled

  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill={isFilled ? color : fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3 13.1035C3 11.0434 3 10.0138 3.468 9.16062C3.9342 8.30652 4.7883 7.77732 6.4956 6.71712L8.2956 5.60022C10.1001 4.47972 11.0028 3.91992 12 3.91992C12.9972 3.91992 13.899 4.47972 15.7044 5.60022L17.5044 6.71712C19.2117 7.77732 20.0658 8.30652 20.5329 9.16062C21 10.0138 21 11.0434 21 13.1026V14.4724C21 17.9824 21 19.7383 19.9452 20.8291C18.8913 21.9199 17.1939 21.9199 13.8 21.9199H10.2C6.8061 21.9199 5.1087 21.9199 4.0548 20.8291C3 19.7383 3 17.9833 3 14.4724V13.1035Z"
        stroke={color}
      />
      <path
        d="M12 15.6201V18.3201"
        stroke={!isFilled ? color : fill}
        className={cn({
          'stroke-primary': isFilled
        })}
        strokeLinecap="round"
      />
    </svg>
  )
}

export default HomeIcon
